import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Paper,
  Divider,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Button,
  Drawer,
  ListItemIcon,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Fade,
  Stack,
  Select,
  IconButton,
  AppBar,
  Toolbar,
  Slide,
  InputLabel,
  CssBaseline,
  ToggleButtonGroup,
  ToggleButton,
  Link,
  CircularProgress,
  Menu,
  TextField,
  InputAdornment,
  SvgIcon,
  Skeleton,
  Breadcrumbs
} from "@mui/material";
import {
  AttachMoney,
  Category,
  Business,
  TrendingUp,
  TrendingDown,
  Remove,
  PieChart,
  Close as CloseIcon,
  CloudUpload,
  Dashboard,
  FileDownload,
  CheckCircle,
  RadioButtonUnchecked,
  AccessTime,
  AutoAwesome,
  Campaign,
  Delete,
  ArrowDropDown,
  ArrowDropDownCircle,
  PriceCheck,
  CreditScore,
  CurrencyExchange,
  Info,
  Groups,
  PersonSearch,
  HelpOutline,
  Speed,
  PanToolAlt,
  TrendingFlat,
  PeopleAltOutlined,
  CampaignOutlined,
  FiberManualRecord,
  AccessTimeFilledOutlined,
  AccessTimeFilled,
  Co2,
  EnergySavingsLeaf,
  Insights,
  InsightsOutlined,
  ArrowUpward,
  ArrowDownward,
  HorizontalRule,
  TrendingUpOutlined,
  TrendingDownOutlined,
  TrendingFlatOutlined,
  FilterCenterFocus,
  TipsAndUpdates,
  NavigateNext,
  ReportProblem,
} from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
import FolderIcon from "@mui/icons-material/Folder";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  LabelList,
  Cell,
  Label,
  Text,
  LineChart,
  Legend,
  Line,
  ComposedChart,
  Treemap,
  Rectangle,
  ScatterChart, Scatter,
  ZAxis,
  ReferenceLine,
  ReferenceArea
} from "recharts";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Tooltip as MUITooltip } from '@mui/material';
import { styled } from "@mui/system";
// import { TrendingDown, Minus, PieChart, ChevronDown ,X} from 'lucide-react';
import { TypeAnimation } from "react-type-animation";
import bggenai from '../../assets/bggenai.png'
import bgsd from "../../assets/bgsd.png";
import ailoader from "../../assets/ailoader.gif";
import bgSS from "../../assets/bgSS.png";
import { DeleteIcon, Search } from "lucide-react";
import { IoIosLocate } from "react-icons/io";
import { FaHome, FaUpload, FaChartBar, FaBars } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
// import { withTranslation } from "react-google-multi-lang";
// import { translateBulk } from "./translationService";
import { TbTopologyStar3 } from "react-icons/tb";


export const SupplierChartFunc = ({ supplierChartData, spendSummary, roleTitle }) => {
  let parsedData;

  if (typeof supplierChartData === "string") {
    try {
      parsedData = JSON.parse(supplierChartData);
      console.log("Parsed supplierChartData:", parsedData);
    } catch (error) {
      console.error("Error parsing supplierChartData:", error);
      return null;
    }
  } else if (typeof supplierChartData === "object" && supplierChartData !== null) {
    parsedData = supplierChartData;
  } else {
    console.error("supplierChartData is not a string or an object");
    return null;
  }
console.log('supplier chart data is', supplierChartData);
  if (roleTitle === "Chief Procurement Officer") {
    // Process data for CPO view
    console.log('supplier chart data is', supplierChartData);
    const supplierAnalysis = parsedData.top_80_supplier_analysis;
    
    // Sort by total spend to show highest spending suppliers first
    const sortedData = [...supplierAnalysis].sort((a, b) => b.total_spend - a.total_spend);
    
    // Take top 10 suppliers with highest spend
    const top10BySpend = sortedData.slice(0, 10);
    console.log(top10BySpend);
  
    const getFirstName = (name) => {
      const maxLength = 12;
      return name.length > maxLength ? `${name.substring(0, maxLength)}...` : name;
    };
  
    return (
      <Box display="flex" flexDirection="column" alignItems="center" mb={2} justifyContent="center">
        <Box display="flex" justifyContent="center" width="100%" position="relative">
          <Box sx={{ flexGrow: 1, height: "auto", position: "relative" }}>
            <ResponsiveContainer width="100%" height={400}>
              <ComposedChart
                layout="horizontal"
                data={top10BySpend}
                margin={{top: 40, right: 60, left: 40, bottom: 25}}
              >
                <defs>
                  <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#BF6FE5" />
                    <stop offset="100%" stopColor="#CA698F" />
                  </linearGradient>
                </defs>
                <XAxis
                  type="category"
                  dataKey="supplier_name"
                  tickFormatter={getFirstName}
                  tick={{
                    fill: "white",
                    fontStyle: "Roboto",
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "18px",
                    textAlign: "center",
                  }}
                  interval={0}
                  axisLine={false}
                  tickLine={false}
                >
                  <Label
                    value="Top Suppliers by Spend"
                    position="bottom"
                    offset={10}
                    style={{
                      fill: "white",
                      textAnchor: "middle",
                      fontStyle: "Roboto",
                      fontSize: "12px",
                      fontWeight: 400,
                    }}
                  />
                </XAxis>
                {/* Single Y-Axis for total spend */}
                <YAxis
                  type="number"
                  dataKey="total_spend"
                  tickFormatter={(value) => new Intl.NumberFormat('en-US', {
                    // style: 'currency',
                    // currency: spendSummary.spend_summary.currency_value,
                    notation: 'compact',
                    maximumFractionDigits: 1
                  }).format(value)}
                  tick={{
                    fill: "white",
                    fontStyle: "Roboto",
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "18px",
                    textAlign: "center",
                  }}
                  axisLine={false}
                  tickLine={false}
                >
                  <Label
                    value={`Total Spend (in ${
                      spendSummary.spend_summary.currency_value === "EUR"
                        ? "€"
                        : spendSummary.spend_summary.currency_value === "USD"
                        ? "$"
                        : spendSummary.spend_summary.currency_value === "GBP"
                        ? "£"
                        : spendSummary.spend_summary.currency_value === "AUD"
                        ? "A$"
                        : spendSummary.spend_summary.currency_value
                    })`}
                    angle={-90}
                    position="insideLeft"
                    style={{
                      fill: "white",
                      fontStyle: "Roboto",
                      fontSize: "12px",
                      fontWeight: 400,
                    }}
                    offset={-20}
                    dy={30}
                  />
                </YAxis>
                <Tooltip
                  formatter={(value, name) => {
                    if (name === "yoy_change") return [`${Math.round(value)}%`, "YoY Change"];
                    if (name === "total_spend") return [
                      new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: spendSummary.spend_summary.currency_value,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(value), 
                      "Total Spend"
                    ];
                    return [value, name];
                  }}
                  cursor={false}
                />
                <Bar
                  dataKey="total_spend"
                  fill="url(#colorGradient)"
                  barSize={50}
                  barCategoryGap="10%"
                  radius={[6, 6, 6, 6]}
                >
                  {top10BySpend.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill="url(#colorGradient)"
                      style={{
                        cursor: "pointer",
                        transition: "fill 0.3s ease",
                      }}
                    />
                  ))}
                  <LabelList
                    dataKey="total_spend"
                    position="center"
                    content={({ x, y, width, height, value }) => (
                      <text
                        x={x + width / 2}
                        y={y + height / 2}
                        fill="#FFF"
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fontStyle="Roboto"
                        fontSize="12px"
                        // fontWeight="bold"
                      >
                  {spendSummary.spend_summary.currency_value ? 
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: spendSummary.spend_summary.currency_value,
    notation: 'compact',
    maximumFractionDigits: 0,
  }).format(value) :
  value // or some other fallback format
}
                      </text>
                    )}
                  />
                </Bar>
                
                {/* Line for YoY Change - Movement indicator */}
                {/* <Line
                  type="monotone"
                  dataKey="yoy_change"
                  stroke="#ffffff"
                  strokeWidth={2}
                  dot={{
                    fill: "#ffffff",
                    stroke: "#ffffff",
                    strokeWidth: 2,
                    r: 4
                  }}
                  isAnimationActive={false}
                  activeDot={{ r: 6, fill: "#ffffff", stroke: "#ffffff" }}
                /> */}
                
                {/* Statements box inside the chart */}
                {/* <ReferenceArea
                  x1={top10BySpend[0].supplier_name}
                  x2={top10BySpend[4].supplier_name}
                  y1={Math.max(...top10BySpend.map(item => item.total_spend)) * 0.65}
                  y2={Math.max(...top10BySpend.map(item => item.total_spend))}
                  shape={() => (
                    <g>
                      <foreignObject
                        x="0" 
                        y="0"
                        width="350" 
                        height="150"
                      >
                     
                      </foreignObject>
                    </g>
                  )}
                /> */}
              </ComposedChart>
            </ResponsiveContainer>

            <Box
                          sx={{
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                            borderRadius: "8px",
                            padding: "10px",
                            color: "white",
                            fontStyle: "Roboto",
                            fontSize: "12px",
                            textAlign: "left",
                            boxShadow: "3px 3px 5px rgba(0, 0, 0, 0.2)",
                            // height: "100%",
                            width:'400px',
                            overflow: "auto",
                            position: "absolute",
                            top:"10px",
                            right:"10px"
                          }}
                        >
                          {/* <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              marginBottom: "5px"
                            }}
                          >
                            Movement Summary
                          </Typography> */}
                          {parsedData.statements && parsedData.statements.map((statement, index) => (
                            <Typography
                              key={index}
                              sx={{
                                fontSize: "13px",
                                textAlign: "left",
                                marginBottom: index < parsedData.statements.length - 1 ? "5px" : 0,
                              }}
                            >
                              <Insights sx={{ mr: 0.5, verticalAlign: "middle", fontSize: "16px" }} />
                              {statement}
                            </Typography>
                          ))}
                        </Box>
          </Box>
        </Box>
      </Box>
    );
  }
  
    const { barChart } = parsedData;
  
    // Sort data based on spend
    const combinedData = barChart.labels
      .map((label, index) => ({
        name: label,
        "Total Spend": barChart.data[index],
      }))
      .sort((a, b) => b["Total Spend"] - a["Total Spend"]);
  
    // Extract top 10 suppliers
    const top10Data = combinedData.slice(0, 10);
  
    // Calculate the total spend of the top 10 suppliers
    const totalSpendTop10 = top10Data.reduce(
      (sum, entry) => sum + entry["Total Spend"],
      0
    );
  
    // Calculate the total spend of all suppliers (including others)
    const totalSpendAll = combinedData.reduce(
      (sum, entry) => sum + entry["Total Spend"],
      0
    );
  
    // Calculate the percentage of spend for the top 10 suppliers
    const totalSpendPercentage = (totalSpendTop10 / totalSpendAll) * 100;
  
    // Calculate suppliers contributing to 80% of spend
    let cumulativeSpend = 0;
    const suppliersFor80Percent = combinedData.filter((supplier) => {
      cumulativeSpend += supplier["Total Spend"];
      return cumulativeSpend <= totalSpendAll * 0.8;
    });
  
    const formatLargeNumber = (number) => {
      if (number >= 1e9) return Math.round(number / 1e9) + "B";  // Handle billions
      if (number >= 1e6) return Math.round(number / 1e6) + "M";  // Handle millions
      if (number >= 1e3) return Math.round(number / 1e3) + "K";  // Handle thousands
      return Math.round(number);  // Handle numbers below 1,000
    };
    
    const getFirstName = (name) => {
      // Maximum length of text before truncating
      const maxLength = 12; // Adjust this as needed
    
      // Truncate and add ellipsis if the name is too long
      return name.length > maxLength ? `${name.substring(0, maxLength)}...` : name;
    };
    
    
    const getSpendContribution = (spend) => {
      return ((spend / totalSpendAll) * 100).toFixed(1);
    };
  
    return (
      <Box display="flex" flexDirection="column" alignItems="center" mb={2} justifyContent="center">
        <Box display="flex" justifyContent="center" width="100%" position="relative">
          <Box sx={{ flexGrow: 1, height: "auto", position: "relative" }}>
            <ResponsiveContainer width="100%" height={400}>
              <BarChart
                layout="horizontal"
                data={top10Data}
                margin={{top: 20, right: 30, left: 40, bottom: 25  }}
              >
                <defs>
                  <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#BF6FE5" />
                    <stop offset="100%" stopColor="#CA698F" />
                  </linearGradient>
                </defs>
                <XAxis
                  type="category"
                  dataKey="name"
                  
                  stroke="white"
                  tickFormatter={getFirstName}
                  tick={{
                    fill: "white",
                    fontStyle: "Roboto",
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "18px",
                    textAlign: "center",
                  }}
                  interval={0}
                  axisLine={{ stroke: "white" }}
                  tickLine={{ stroke: "white" }}
                  width={100}
                >
                  <Label
                    value="Top 10 Suppliers"
                    position="bottom"
                    offset={10}
                    style={{
                      fill: "white",
                      textAnchor: "middle",
                      fontStyle: "Roboto",
                      fontSize: "12px",
                      fontWeight: 400,
                      textAnchor: "middle",
                    }}
                    // offset={-5}
                  />
                </XAxis>
                <YAxis
                  type="number"
                  stroke="white"
                  tickFormatter={formatLargeNumber}
                  tick={{
                    fill: "white",
                    fontStyle: "Roboto",
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "18px",
                    textAlign: "center",
                  }}
                >
                  <Label
                     value={`Total Spend (in ${
                      spendSummary.spend_summary.currency_value === "EUR"
                        ? "€"
                        : spendSummary.spend_summary.currency_value === "USD"
                        ? "$"
                        : spendSummary.spend_summary.currency_value === "GBP"
                        ? "£"
                        : spendSummary.spend_summary.currency_value === "AUD"
                        ? "A$"
                        : spendSummary.spend_summary.currency_value
                    })`}
                    angle={-90}
                    position="insideLeft"
                    style={{
                      fill: "white",
                      fontStyle: "Roboto",
                      fontSize: "12px",
                      fontWeight: 400,
                    }}
                    offset={-20}
                    dy={30}
                  />
                </YAxis>
                <Tooltip
                  formatter={(value, name) => [
                    name === "Total Spend"
                      ? formatLargeNumber(value)
                      : `${Math.round(value)}%`,
                    name,
                  ]}
                  cursor={{ fill: "transparent" }}
                />
                <Bar
                  dataKey="Total Spend"
                  fill="url(#colorGradient)"
                  barSize={70}
                  barCategoryGap="10%"
                  radius={[6, 6, 0, 0]}
                >
                  {top10Data.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill="url(#colorGradient)"
                      style={{
                        cursor: "pointer",
                        transition: "fill 0.3s ease",
                      }}
                    />
                  ))}
                  <LabelList
                    dataKey="Total Spend"
                    position="insideTop"
                    content={({ x, y, width, height, value }) => (
                      <text
                        x={x + width / 2}
                        y={y + height / 2}
                        fill="#FFF"
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fontStyle="Roboto"
                        fontSize="10px"
                      >
                        {`${formatLargeNumber(value)} (${Math.round(
                          (value / totalSpendAll) * 100
                        )}%)`}
                      </text>
                    )}
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
  
            {/* Details Box in the top right corner */}
            <Box
  sx={{
    position: "absolute",
    top: 0,
    right: 20,
    width: "400px",
    height: "auto",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    borderRadius: "8px",
    padding: "10px",
    color: "white",
    fontStyle: "Roboto",
    fontSize: "12px",
    textAlign: "left",
    boxShadow: "3px 3px 5px rgba(0, 0, 0, 0.2)",
    zIndex: 1,
    marginBottom: "2rem",
  }}
>
  <Typography
    sx={{
      fontSize: "14px",
      textAlign: "left",
      marginBottom: "5px",
    }}
  >
    <Insights sx={{ mr: 0.5, verticalAlign: "middle", fontSize: "20px" }} />
    Top {Math.min(10, suppliersFor80Percent.length+1)} suppliers contribute to {Math.round(totalSpendPercentage)}% spend
  </Typography>
  
  {suppliersFor80Percent.length >= 3 && (
    <Typography
      sx={{
        fontSize: "14px",
        textAlign: "left",
      }}
    >
      <Insights sx={{ mr: 0.5, verticalAlign: "middle", fontSize: "20px" }} />
      {suppliersFor80Percent.slice(0, 3).map((supplier, index) => (
        <span key={index}>
          {supplier.name} ({Math.round(getSpendContribution(supplier["Total Spend"]))}%)
          {index < 2 ? ", " : ""}
        </span>
      ))}
      {suppliersFor80Percent.length > 3 && (
        <span> and {suppliersFor80Percent.length - 3} others contribute to 80% of spend</span>
      )}
    </Typography>
  )}
</Box>
          </Box>
        </Box>
      </Box>
    );
  };
 